<template>
  <div class="app-container no-bg">
    <div class="top-box flex jbetween acenter bg-white br10 pl24 pr24">
      <div class="user-box flex acenter">
        <img src="@/assets/img/v2/common/avatar-default-big.png" class="size70 br-circle mr20" />
        <div class="info-box flex vertical mt6">
          <span class="font-24 fw-600">{{$t('Hi')}}，{{ $userInfo.loginName }}</span>
          <div class="flex acenter mt15">
            <img src="@/assets/img/v2/common/post.png" class="size14 mr8" />
            <span class="font-14 color-606">{{ $userInfo.cusName }}</span>
          </div>
        </div>
      </div>

      <div class="todo-container flex jbetween acenter" v-loading="todoLoading">
        <div v-for="todo in todoLists" :key="todo.id" class="todo-box flex vertical pointer" :class="[{ 'todo-box-small': anniversary }, `todo-box-${lang}`]" @click="$go(todo.url)">
          <span class="font-16 color-1c todo-box-name">{{ todo.name }}</span>
          <span class="todo-count">{{ todo.data }}</span>
        </div>
      </div>
    </div>

    <div class="bottom-container flex vertical mt24">
      <div class="function-container flex jbetween acenter br10">
        <div class="shortcut-container flex vertical flex-1 br10 bg-white mr24">
          <div class="title-box">
            <span class="title-text">{{$t('workbench.shortcuts')}}</span>
          </div>
          <div class="shortcut-list flex wrap jbetween mt51 pl22 pr22">
            <div v-for="(shortcut, index) in shortcutList" class="shortcut-box flex vertical acenter mb51 pointer" :class="`shortcut-box-${ lang }`" @click="shortcutClick(shortcut)">
              <img :src="require(`@/assets/img/v2/index/shortcut${index % 4}.png`)" class="size40 mb10" />
              <span class="font-14 color-1c">{{ shortcut.name }}</span>
            </div>
            <div v-for="i in 10" class="size56 ml42 mr42 mb51"></div>
          </div>
        </div>

        <div class="right-container flex acenter">
          <month-calendar class="index-calendar" :year="$today('YYYY')" :month="$today('MM')" disabled margin="0 24px 0 0" :hover-effect="false"></month-calendar>

          <div class="news-container flex vertical br10">
            <div class="title-box">
              <span class="title-text">{{$t('workbench.policyExpress')}}</span>
              <span class="title-text font-16 color-9 pointer" @click="$go('/information')">{{$t('more')}}</span>
            </div>
            <div class="flex vertical mt18 pl24 pr24">
              <div v-for="news in newsList" :key="news.id" class="news-box flex vertical mb22 pointer" @click="$open(news.essayUrl)">
                <span class="font-16 fw-500 color-3 hl22 text-ellipsis">{{ news.essayTitle }}</span>
                <span class="font-14 color-9 hl20 mt8">{{ $formatDate(news.updateTime) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="stats-container flex jbetween mt24">
        <div class="salary-stats-container flex-1 br10 bg-white mr24" v-loading="statsData.salaryMonth.loading">
          <div class="title-box">
            <div class="title-left">
              <span class="title-text">{{$t('salaryOverview')}}</span>
            </div>
            <div class="title-right flex acenter">
              <el-radio-group class="radio-group-v2" v-model="statsData.salaryMonth.type" size="small" @input="getStatsData('salaryMonth')">
                <el-radio-button label="sum">{{$t('total')}}</el-radio-button>
                <el-radio-button label="avg">{{$t('average')}}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <salary-chart :chart-data="statsData.salaryMonth.data" margin="17px 0 0 0"></salary-chart>
        </div>

        <div class="emp-stats-container br10 bg-white" v-loading="statsData.empChange.loading">
          <div class="title-box">
            <span class="title-text">{{$t('personnelOverview')}}</span>
          </div>
          <emp-chart :chart-data="statsData.empChange.data" margin="17px 0 0 0"></emp-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryPendingList, queryPendingNum, queryNewsList } from '@/api/msg/msg'
import { getAnniversaryCount } from '@/api/wage/ysqh'
import {aveLog} from "@/api/user/user";
import * as apiBoard from '@/api/v2/stats/data-center/board'
import MonthCalendar from '@/air/components/calendar/MonthCalendar'
import SalaryChart from './components/SalaryChart'
import EmpChart from './components/EmpChart'
import { mapGetters } from 'vuex';
export default {
  name: 'Index',
  components: {
    MonthCalendar,
    SalaryChart,
    EmpChart
  },
  data() {
    return {
      todoLoading: true,
      todoLists: [],
      anniversary:false,
      shortcutList: [],
      newsLoading: true,
      newsList: [],
      statsData: {
        empChange: {
          loading: true,
          monthStart: '',
          monthEnd: '',
          data: {
            v_92740007: []
          },
        },
        salaryMonth: {
          loading: true,
          monthStart: '',
          monthEnd: '',
          type: 'sum',
          data: {
            v_92740012: []
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.initTodo()
      this.initShortcutList()
      this.initNews()
      this.initStats()
    },
    initTodo() {
      let ruZhi = JSON.parse(sessionStorage.getItem('ruZhi'))
      let yuanGong = JSON.parse(sessionStorage.getItem('yuanGong'))
      let heTong = JSON.parse(sessionStorage.getItem('heTong'))
      let xinZi = JSON.parse(sessionStorage.getItem('xinZi'))
      queryPendingList().then(async (res) => {
        let todoLists = res.data.data
        if (todoLists != null && todoLists.length > 0) {
          for (let i = 0; i < todoLists.length; i++) {
            todoLists[i].data = 0
          }
        }
        if (ruZhi !== '入职管理') {
          todoLists[0].url = '#'
        }
        if (yuanGong !== '员工管理') {
          todoLists[1].url = '#'
        }
        if (heTong !== '合同管理') {
          todoLists[2].url = '#'
        }
        if (yuanGong !== '员工管理') {
          todoLists[3].url = '#'
        }
        if (xinZi !== '薪资待完成') {
          todoLists[4].url = '#'
        }
        this.todoLists = todoLists
        //遍历请求数量
        for (let i = 0; i < this.todoLists.length; i++) {
          this.queryPendingNum(i)
        }
        if (this.$userInfo.cusId === '9999011234' || this.$userInfo.cusId === '9999007182') {
          //原生启恒显示纪念日提醒
          await getAnniversaryCount({
            param:JSON.stringify({
              cusId:this.$userInfo.cusId
            })
          }).then(res=>{
            this.anniversary = true
            this.todoLists.push(
              {
                data: res.data.data.oneanni,
                name: '一周年提醒',
                url: '/wage/anniversary'
              },
              {
                data: res.data.data.threeanni,
                name: '三周年提醒',
                url: '/wage/anniversary'
              },
              {
                data: res.data.data.fiveanni,
                name: '五周年提醒',
                url: '/wage/anniversary'
              }
            )
          })
        }
        this.todoLoading = false
      })
    },
    //加载待办数量
    queryPendingNum(i) {
      queryPendingNum(this.todoLists[i].funcSign).then((res) => {
        this.todoLists[i].data = res.data.data
      })
    },
    initShortcutList() {
      let allList = [
        {zhName: '数据中心', name: this.$t('menu.dataCenter'), path: '/v2/stats/data-center', permission: 'hr_wage_new_report_data_center'},
        {zhName: '入职管理', name: this.$t('menu.onboardingManagement'), path: '/per/perEntryPage.action', permission: 'hr_set_entry'},
        {zhName: '员工管理', name: this.$t('menu.staffManagement'), path: '/per/toPerList.action?sysFunctionCode=OTA4NDAwMTY-', permission: 'hr_emp_manage'},
        {zhName: '合同管理', name: this.$t('menu.contractManagement'), path: '/contract/toContractManage.action', permission: 'hr_contract_manage'},
        {zhName: '打卡记录', name: this.$t('menu.clockInRecords'), path: '/atndclockrecord/toindex.action', permission: 'hr_clock_record'},
        {zhName: '考勤汇总', name: this.$t('menu.attendanceSummary'), path: '/atndmonthlyreport/toSummary.action', permission: 'hr_atnd_sum'},
        {zhName: '数据准备', name: this.$t('menu.dataPreparation'), path: '/wage/data-ready-template', permission: 'hr_wage__new_data_ready'},
        {zhName: '薪酬发放', name: this.$t('menu.salaryDistribution'), path: '/wage/paymentWage', permission: 'hr_wage_new_pay'},
        {zhName: '个税申报', name: this.$t('menu.IITDeclaration'), path: '/wage/salaryTax', permission: 'hr_wage_new_tax'},
        {zhName: '薪酬审批', name: this.$t('menu.salaryApproval'), path: '/wage/salaryApproval', permission: 'hr_wage_new_approve'},
      ]
      this.shortcutList = allList.filter(item => {
        return this.$permissionSet.has(item.permission)
      })
    },
    initNews() {
      queryNewsList('new', { currentPage: 1, pageSize: 4 }).then(res => {
        this.newsList = res.data.data.records.slice(0, 4)
        this.newsLoading = false
      })
    },
    initStats() {
      for (let type in this.statsData) {
        // 初始化参数
        const year = this.$day().format('YYYY')
        this.statsData[type].monthStart = `${year}-01`
        this.statsData[type].monthEnd = `${year}-12`
        this.getStatsData(type)
      }
    },
    getStatsData(type) {
      this.statsData[type].loading = true
      apiBoard[type](this.statsData[type]).then(res => {
        this.statsData[type].data = res.data.data
        this.statsData[type].loading = false
      })
    },
    shortcutClick(shortcut) {
      const { path, name} = shortcut;
      this.$go(path)
      aveLog({ operFunname: name })
        .then(res => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.top-box {
  min-width: 1664px;
  height: 160px;

  .todo-box {
    width: 169px;
    margin-left: 70px;

    &.todo-box-small {
      width: 130px;
      margin-left: 25px;
    }
    &.todo-box-en {
      .todo-box-name {
        height: 32px;
      }
    }
    .todo-count {
      font-size: 32px;
      font-family: FZYDCHJW--GB1-0, FZYDCHJW--GB1;
      font-weight: 600;
      color: #1C1C1C;
      line-height: 38px;
      border-right: 1px solid #DEDEDE;
      margin-top: 6px;
    }
    &:last-child {
      .todo-count {
        border-right: none;
      }
    }
  }
}
.bottom-container {
  .function-container {
    .shortcut-container {
      min-width: 908px;
      height: 360px;
      .shortcut-box-en {
        width: 25%;
      }
      .shortcut-box-zh {
        margin-left: 42px;
        margin-right: 42px;
      }
    }
    .right-container {
      width: 732px;

      .index-calendar {
        width: 354px;
        flex: 0 0 354px;
        height: 360px;
        background-color: #FFFFFF;
        border-radius: 10px;

        ::v-deep .air-calendar-month__title {
          width: 100%;
          height: 23px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1C1C1C;
          line-height: 24px;
          padding: 18px 24px;
          border-bottom: 1px solid #E8E8E8;
        }
        ::v-deep .air-calendar-month__body {
          width: auto;
          padding: 18px;

          .month__week-title span {
            width: 45px;
          }
          .month__days .day__body {
            width: 45px;
          }
        }
      }
      .news-container {
        width: 354px;
        flex: 0 0 354px;
        background-color: #FFFFFF;
        height: 360px;

        .news-box {
          .news-title {
            width: 305px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
          }
          .news-abstract {
            width: 305px;
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
          }
        }
      }
    }
  }

  .stats-container {
    .salary-stats-container {
      min-width: 908px;
      height: 340px;
    }
    .emp-stats-container {
      width: 732px;
      flex: 0 0 732px;
      height: 340px;
    }
  }
}
</style>
